import React, { useState, useEffect } from 'react';
import { CircularProgress, Grid, Paper, Avatar, TextField, Button } from '@mui/material';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import { useAuth } from '../../context/AuthContext';
import { useNavigate } from 'react-router-dom';
import './Login.css';

const Login = ({ onLogin }: any) => {
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [newPassword, setNewPassword] = useState('');
    const [showNewPasswordField, setShowNewPasswordField] = useState(false);
    const navigate = useNavigate();
    const { loading, error, login, token } = useAuth();

    useEffect(() => {
        if (error === "NEW_PASSWORD_REQUIRED") {
            setShowNewPasswordField(true);
        }
    }, [error]);

    useEffect(() => {
        if (token) {
            navigate('/dashboard');
        }
    }, [token, navigate]);

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();
        try {
            await login(username, password, newPassword);
        } catch (error) {
            console.error('Login failed:', error);
        }
    };

    const paperStyle = { padding: 20, height: '70vh', width: 280, margin: "20px auto" };
    const avatarStyle = { backgroundColor: '#902427' };
    const btnstyle = { margin: '8px 0' };

    return (
        <Grid component="form" onSubmit={handleSubmit} noValidate sx={{ mt: 1 }}>
            <Paper elevation={10} style={paperStyle}>
                <Grid>
                    <Avatar style={avatarStyle}><LockOutlinedIcon /></Avatar>
                    <h2>Sign In</h2>
                </Grid>
                <TextField
                    margin="normal"
                    required
                    fullWidth
                    id="username"
                    label='Username'
                    name="username"
                    autoComplete="username"
                    placeholder='Enter username'
                    variant="outlined"
                    autoFocus
                    value={username}
                    onChange={(e) => setUsername(e.target.value)}
                    InputLabelProps={{ shrink: true, className: 'custom-label' }}
                />
                <TextField
                    margin="normal"
                    fullWidth
                    required
                    label='Password'
                    type='password'
                    id="password"
                    autoComplete="current-password"
                    placeholder='Enter password'
                    variant="outlined"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    InputLabelProps={{ shrink: true, className: 'custom-label' }}
                />
                {showNewPasswordField && (
                    <TextField
                        margin="normal"
                        fullWidth
                        required
                        label='New Password'
                        type='password'
                        id="newPassword"
                        autoComplete="new-password"
                        placeholder='Enter new password'
                        variant="outlined"
                        value={newPassword}
                        onChange={(e) => setNewPassword(e.target.value)}
                        InputLabelProps={{ shrink: true, className: 'custom-label' }}
                    />
                )}
                <div>
                    {loading ? (
                        <div className='circular-progress-icon margin-top'>
                            <CircularProgress />
                        </div>
                    ) : (
                        <Button type='submit' color='primary' variant="contained" style={btnstyle} fullWidth>Sign in</Button>
                    )}
                </div>
            </Paper>
        </Grid>
    );
};

export default Login;
